module.exports = __webpack_public_path__ + "img/bannerNaMesa.cba1d95a.jpeg";